<atn-ds-table [config]="usersTableConfig" />

<atn-admin-user-assignment-modal [hasAppPages]="true" />

@let markedUserForUnassignment =
  userAssignmentFeature.selectors.markedUserForUnassignment.asSignal();
@if (markedUserForUnassignment) {
  @let mutationError =
    userAssignmentFeature.selectors.mutationErrorMessage.asSignal();
  <atn-ds-confirmation-overlay
    title="Unassign User"
    [description]="
      'Unassigning ' +
      markedUserForUnassignment.name +
      ' from this app can\'t be undone. Are you sure you want to continue?'
    "
    [error]="mutationError"
    (cancel)="cancelUnassignmentClickHandler()"
    (confirm)="confirmUnassignmentClickHandler()"
    confirmButtonText="Confirm"
  />
}
